/* PrimeFone navigatie (DESIGNCONCEPT §4, BLOK-M): desktopdropdowns en de schermen van de mobiele lade.
   - Dropdown: hover met 150 ms vertraging en een sluitvertraging als "veilige driehoek"; klik, Enter of Spatie op het
     pijltje opent ook. Esc sluit en zet de focus terug, klikken buiten het paneel sluit, aria-expanded klopt altijd.
   - Series, modellen en "vanaf"-prijzen: PrimeFoneRefurbData (zelfde bron en strikte voorraadregel als de collectie).
     Geen voorraad of geen data = geen prijs en geen verzonnen modellen.
   - Toestel voor accessoires: dezelfde opslag als de categoriepagina's (localStorage "pf-device") en de bestaande
     modelkiezer (#pf-model-picker). Op pagina's zonder modelkiezer wordt het sjabloon uit de header gebruikt.
   Openen/sluiten van de lade, focusval en Esc zitten in theme.js; dit script wisselt alleen de schermen. */
(function () {
  'use strict';
  if (window.pfNavInstalled) return;
  window.pfNavInstalled = true;
  const cfgNode = document.querySelector('[data-pfn-config]');
  const cfg = cfgNode ? JSON.parse(cfgNode.textContent) : {};
  const STORE = 'pf-device', CACHE = 'pf-nav-v1', CACHE_MS = 10 * 60 * 1000;
  const el = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text !== undefined) n.textContent = text; return n; };
  const money = cents => '€ ' + new Intl.NumberFormat('nl-NL', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(cents / 100);
  const chev = () => { const s = document.createElementNS('http://www.w3.org/2000/svg', 'svg'); s.setAttribute('class', 'pfn-chev'); s.setAttribute('width', '16'); s.setAttribute('height', '16'); s.setAttribute('viewBox', '0 0 24 24'); s.setAttribute('fill', 'none'); s.setAttribute('stroke', 'currentColor'); s.setAttribute('stroke-width', '2.2'); s.setAttribute('stroke-linecap', 'round'); s.setAttribute('stroke-linejoin', 'round'); s.setAttribute('aria-hidden', 'true'); const p = document.createElementNS('http://www.w3.org/2000/svg', 'path'); p.setAttribute('d', 'm9 6 6 6-6 6'); s.append(p); return s; };
  const thumb = (src, cls) => { const t = el('span', cls || 'pfn-thumb'); if (src) { const i = el('img'); i.src = src; i.alt = ''; i.width = 120; i.height = 120; i.loading = 'lazy'; i.decoding = 'async'; i.addEventListener('error', () => i.remove(), { once: true }); t.append(i); } return t; };
  const NEUTRAL = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="7" y="2.5" width="10" height="19" rx="2.4"/><path d="M11 18.5h2"/></svg>';
  // Foto van precies deze serie of dit model (echte variantfoto); zonder foto een neutraal toestelicoon, nooit een ander model.
  const media = (src, cls) => { const t = el('span', cls); t.setAttribute('aria-hidden', 'true'); const fallback = () => { t.innerHTML = NEUTRAL; }; if (src) { const i = el('img'); i.src = src; i.alt = ''; i.width = 160; i.height = 160; i.loading = 'lazy'; i.decoding = 'async'; i.addEventListener('error', fallback, { once: true }); t.append(i); } else fallback(); return t; };
  // Menufoto's zijn hooguit 160 px breed; op retina de 2x-versie (320 px). Zelfde URL bij vooraf laden en tonen, dus uit de cache.
  const PX = (window.devicePixelRatio || 1) > 1 ? 320 : 160;
  const sized = src => { if (!src || !/cdn\.shopify|\/cdn\//.test(src)) return src; try { const u = new URL(src, location.origin); u.searchParams.set('width', String(PX)); return u.toString(); } catch (e) { return src; } };

  /* ── Catalogus: series met modellen, laagste prijs en een echte foto ─────────────────────────── */
  let catalog = null, loading = null, failed = false;
  const seriesName = m => (window.PrimeFoneRefurbData && window.PrimeFoneRefurbData.seriesName) ? window.PrimeFoneRefurbData.seriesName(m) : (m.match(/^iPhone (\d+|SE|X)/) || [m])[0];
  const seriesLabel = n => n === 'iPhone SE' ? n : n + '-serie';
  function readCache() { try { const v = JSON.parse(sessionStorage.getItem(CACHE)); return v && v.url === cfg.collectionUrl && Date.now() - v.time < CACHE_MS ? v.catalog : null; } catch (e) { return null; } }
  function writeCache(c) { try { sessionStorage.setItem(CACHE, JSON.stringify({ time: Date.now(), url: cfg.collectionUrl, catalog: c })); } catch (e) { /* geen opslag */ } }
  function build(core, products) {
    const D = window.PrimeFoneRefurbData;
    const rows = core.hydrate(products, D.rules).rows; // alleen strikt verkoopbare varianten
    const base = new URL(cfg.collectionUrl, location.origin).href;
    const link = v => core.url(base, Object.assign({}, core.empty(), v));
    const series = [];
    for (const model of core.facets(rows, core.empty(), D.rules).model) {
      const mRows = rows.filter(r => r.model === model);
      if (!mRows.length) continue;
      const min = Math.min(...mRows.map(r => r.price));
      const img = (mRows.find(r => r.image) || {}).image || null;
      const name = seriesName(model);
      let s = series.find(x => x.name === name);
      if (!s) series.push(s = { name, models: [] });
      s.models.push({ name: model, min, image: img, url: link({ model: [model] }) });
    }
    series.forEach(s => { s.min = Math.min(...s.models.map(m => m.min)); s.image = (s.models.find(m => m.image) || {}).image || null; s.url = link({ model: s.models.map(m => m.name) }); });
    const conditions = core.conditions.filter(c => rows.some(r => r.condition === c));
    return { series, conditions };
  }
  function ensure() {
    if (catalog) return Promise.resolve(catalog);
    if (loading) return loading;
    const cached = readCache(); if (cached) { catalog = cached; renderAll(); return Promise.resolve(catalog); }
    const D = window.PrimeFoneRefurbData;
    if (!D) { failed = true; renderAll(); return Promise.resolve(null); }
    failed = false;
    loading = D.load().then(([core, products]) => { catalog = build(core, products); writeCache(catalog); return catalog; })
      .catch(() => { failed = true; return null; })
      .finally(() => { loading = null; renderAll(); });
    return loading;
  }

  /* ── Vooraf laden als de pagina rustig is (requestIdleCallback, anders setTimeout) ───────────────── */
  const warmed = new Set();
  const warmImg = src => { if (!src || warmed.has(src)) return; warmed.add(src); const i = new Image(); i.decoding = 'async'; i.src = src; };
  function warm() {
    // Vaste menufoto's (accessoires, condities, mobiel menu): lazy in een verborgen paneel, dus nu alvast in de cache.
    document.querySelectorAll('[data-pfn-panel] img[src], #MobileNav img[src]').forEach(i => warmImg(i.getAttribute('src')));
    // Series en modellen: zelfde bron en voorraadregel als bij openen (ensure), daarna hun foto's.
    ensure().then(c => { if (c) c.series.forEach(s => { warmImg(sized(s.image)); s.models.forEach(m => warmImg(sized(m.image))); }); });
  }
  const whenIdle = cb => ('requestIdleCallback' in window) ? requestIdleCallback(cb, { timeout: 2500 }) : setTimeout(cb, 1200);
  if (document.readyState === 'complete') whenIdle(warm); else window.addEventListener('load', () => whenIdle(warm), { once: true });

  /* ── Desktop: Refurbished-dropdown ─────────────────────────────────────────────────────────── */
  const desk = document.querySelector('[data-pfn-panel="refurb"]');
  let current = null;
  function status(host, text, retry) { const p = el('p', 'pfn-status', text); host.replaceChildren(p); if (retry) { const b = el('button', 'pfn-retry', 'Opnieuw proberen'); b.type = 'button'; b.addEventListener('click', () => { failed = false; ensure(); }); host.append(b); } }
  function renderDesktop() {
    if (!desk) return;
    const sHost = desk.querySelector('[data-pfn-series]'), mHost = desk.querySelector('[data-pfn-models]');
    if (!catalog) { status(sHost, failed ? 'De series konden niet worden geladen.' : 'Series laden…', failed); mHost.replaceChildren(); return; }
    if (!catalog.series.length) { status(sHost, 'Er zijn nu geen refurbished iPhones op voorraad.'); mHost.replaceChildren(); return; }
    if (!current || !catalog.series.some(s => s.name === current)) current = catalog.series[0].name;
    if (!sHost.dataset.built) {
      sHost.dataset.built = '1';
      sHost.replaceChildren(...catalog.series.map(s => {
        const a = el('a', 'pfn-series__btn'); a.href = s.url; a.dataset.series = s.name;
        const txt = el('span'); txt.append(el('span', 'pfn-name', s.name), el('span', 'pfn-price', 'vanaf ' + money(s.min)));
        a.append(media(sized(s.image), 'pfn-sthumb'), txt, chev());
        const pick = () => { if (current !== s.name) { current = s.name; renderDesktop(); } };
        a.addEventListener('pointerenter', pick); a.addEventListener('focus', pick);
        return a;
      }));
    }
    sHost.querySelectorAll('[data-series]').forEach(n => n.setAttribute('aria-current', String(n.dataset.series === current)));
    const s = catalog.series.find(x => x.name === current);
    desk.querySelector('[data-pfn-series-title]').textContent = seriesLabel(s.name);
    const sl = desk.querySelector('[data-pfn-series-link]'); sl.hidden = false; sl.href = s.url; sl.textContent = 'Alle ' + s.name.replace('iPhone ', '') + '-modellen →';
    mHost.style.setProperty('--pfn-cols', s.models.length >= 5 ? 5 : 4);
    mHost.replaceChildren(...s.models.map(m => {
      const a = el('a', 'pfn-mcard'); a.href = m.url;
      a.append(media(sized(m.image), 'pfn-mcard__media'), el('span', 'pfn-name', m.name), el('span', 'pfn-price', 'vanaf ' + money(m.min))); return a;
    }));
    // Conditiekaarten alleen tonen als die conditie echt op voorraad is.
    desk.querySelectorAll('[data-pfn-cond]').forEach(c => { c.hidden = !catalog.conditions.includes(c.dataset.pfnCond); });
  }

  /* ── Mobiel: hoofdscherm en Refurbished-scherm ────────────────────────────────────────────── */
  const drawer = document.getElementById('MobileNav');
  function renderMobile() {
    if (!drawer) return;
    const s4 = drawer.querySelector('[data-pfm-series4]'), sAll = drawer.querySelector('[data-pfm-series]');
    const mWrap = drawer.querySelector('[data-pfm-models-wrap]'), mHost = drawer.querySelector('[data-pfm-models]');
    if (!catalog) { if (failed) status(sAll, 'De series konden niet worden geladen.', true); return; }
    if (!catalog.series.length) { status(sAll, 'Er zijn nu geen refurbished iPhones op voorraad.'); return; }
    s4.replaceChildren(...catalog.series.slice(0, 4).map(s => {
      const a = el('a', 'pfm-rtile'); a.href = s.url;
      a.append(media(sized(s.image), 'pfm-rtile__media'), el('span', 'pfn-name', s.name), el('span', 'pfn-price', 'vanaf ' + money(s.min))); return a;
    }));
    sAll.replaceChildren(...catalog.series.map(s => {
      const a = el('a', 'pfm-rtile'); a.href = s.url;
      a.append(media(sized(s.image), 'pfm-rtile__media'), el('span', 'pfn-name', s.name), el('span', 'pfn-price', 'vanaf ' + money(s.min))); return a;
    }));
    const models = catalog.series.flatMap(s => s.models);
    mWrap.hidden = !models.length;
    mHost.replaceChildren(...models.map(m => { const a = el('a', '', m.name); a.href = m.url; return a; }));
    drawer.querySelectorAll('.pfm__conds [href*="pf_condition="]').forEach(a => { const c = decodeURIComponent((a.getAttribute('href').split('pf_condition=')[1] || '').replace(/\+/g, ' ')); a.hidden = !catalog.conditions.includes(c); });
  }
  function renderAll() { renderDesktop(); renderMobile(); }

  /* ── Mobiel: schermen wisselen ─────────────────────────────────────────────────────────────── */
  let backTo = null;
  function show(name, focusEl) {
    if (!drawer) return;
    drawer.querySelectorAll('[data-pfm-screen]').forEach(sc => {
      const on = sc.dataset.pfmScreen === name;
      if (on && sc.hidden) { sc.hidden = false; sc.classList.remove('is-entering'); void sc.offsetWidth; sc.classList.add('is-entering'); }
      else if (!on) sc.hidden = true;
    });
    const target = focusEl || drawer.querySelector('[data-pfm-screen="' + name + '"] [data-pfm-back], [data-pfm-screen="' + name + '"] [data-pf-menu-close]');
    if (target) target.focus({ preventScroll: true });
  }
  if (drawer) {
    drawer.addEventListener('click', e => {
      const open = e.target.closest('[data-pfm-open]');
      if (open) { backTo = open; show(open.dataset.pfmOpen); if (open.dataset.pfmOpen === 'refurb') ensure(); return; }
      if (e.target.closest('[data-pfm-back]')) { show('main', backTo && drawer.contains(backTo) ? backTo : null); backTo = null; }
    });
    // Bij openen altijd op het hoofdscherm beginnen en de data alvast laden.
    document.querySelectorAll('[data-pf-menu-toggle]').forEach(b => b.addEventListener('click', () => { show('main', null); ensure(); setTimeout(() => { const c = drawer.querySelector('[data-pfm-screen="main"] [data-pf-menu-close]'); if (c && drawer.classList.contains('is-open')) c.focus({ preventScroll: true }); }, 0); }, true));
    new MutationObserver(() => { document.documentElement.classList.toggle('pfm-open', drawer.classList.contains('is-open')); }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  /* ── Desktop: dropdown openen en sluiten ──────────────────────────────────────────────────── */
  const nav = document.querySelector('[data-pfn]');
  const backdrop = document.querySelector('[data-pf-nav-backdrop]');
  const items = nav ? [...nav.querySelectorAll('[data-pfn-item]')] : [];
  let openTimer = 0, closeTimer = 0;
  function setOpen(item, open) {
    item.classList.toggle('is-open', open);
    const t = item.querySelector('[data-pfn-toggle]'); if (t) t.setAttribute('aria-expanded', String(open));
    if (open) {
      const header = document.querySelector('[data-pf-header]');
      const bottom = header ? header.getBoundingClientRect().bottom : 0;
      document.documentElement.style.setProperty('--pf-panel-top', bottom + 'px');
      if (item.querySelector('[data-pfn-panel="refurb"]')) ensure();
      if (item.querySelector('[data-pfn-panel="acc"]')) refreshDevice();
    }
    const any = items.some(i => i.classList.contains('is-open'));
    if (backdrop) { backdrop.hidden = !any; const h = document.querySelector('[data-pf-header]'); if (h) backdrop.style.setProperty('--pf-header-bottom', h.getBoundingClientRect().bottom + 'px'); }
  }
  const closeAll = except => items.forEach(i => { if (i !== except && i.classList.contains('is-open')) setOpen(i, false); });
  const pickerOpen = () => !!document.querySelector('dialog[open]');
  items.forEach(item => {
    const toggle = item.querySelector('[data-pfn-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', () => { clearTimeout(openTimer); const open = !item.classList.contains('is-open'); closeAll(item); setOpen(item, open); });
    toggle.addEventListener('keydown', e => {
      if (e.key === 'ArrowDown') { e.preventDefault(); closeAll(item); setOpen(item, true); requestAnimationFrame(() => { const f = item.querySelector('.pfn-panel a, .pfn-panel button'); if (f) f.focus(); }); }
    });
    item.addEventListener('pointerenter', e => {
      if (e.pointerType === 'touch') return;
      clearTimeout(closeTimer);
      if (item.classList.contains('is-open')) return;
      clearTimeout(openTimer);
      const delay = items.some(i => i.classList.contains('is-open')) ? 60 : 150;
      openTimer = setTimeout(() => { closeAll(item); setOpen(item, true); }, delay);
    });
    item.addEventListener('pointerleave', e => {
      if (e.pointerType === 'touch') return;
      clearTimeout(openTimer);
      // Sluitvertraging: schuin naar het paneel bewegen sluit het menu niet ("veilige driehoek").
      closeTimer = setTimeout(() => { if (!item.contains(document.activeElement) && !pickerOpen()) setOpen(item, false); }, 260);
    });
    item.addEventListener('keydown', e => {
      if (e.key === 'Escape' && item.classList.contains('is-open')) { e.preventDefault(); e.stopPropagation(); setOpen(item, false); toggle.focus(); }
    });
    item.addEventListener('focusout', () => { setTimeout(() => { if (item.classList.contains('is-open') && !item.contains(document.activeElement) && !pickerOpen()) setOpen(item, false); }, 0); });
  });
  // Andere navigatielink krijgt focus: open paneel dicht.
  if (nav) nav.addEventListener('focusin', e => { const owner = e.target.closest('[data-pfn-item]'); closeAll(owner && owner.classList.contains('is-open') ? owner : null); });
  document.addEventListener('click', e => { if (!e.target.closest('[data-pfn-item]') && !e.target.closest('dialog')) closeAll(); });
  // Esc sluit ook een paneel dat met de muis is geopend; de focus gaat alleen terug als die in het paneel stond.
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape' || pickerOpen()) return;
    const open = items.find(i => i.classList.contains('is-open'));
    if (!open) return;
    const inside = open.contains(document.activeElement);
    setOpen(open, false);
    if (inside) { const t = open.querySelector('[data-pfn-toggle]'); if (t) t.focus(); }
  });
  window.addEventListener('resize', () => closeAll());

  /* ── Toestel voor accessoires (bestaande modelkiezer en opslag) ───────────────────────────── */
  const readDevice = () => { try { return localStorage.getItem(STORE) || ''; } catch (e) { return ''; } };
  const writeDevice = v => { try { if (v) localStorage.setItem(STORE, v); else localStorage.removeItem(STORE); } catch (e) { /* geen opslag */ } };
  function refreshDevice() {
    const model = readDevice();
    document.querySelectorAll('[data-pfn-device]').forEach(box => {
      const text = box.querySelector('[data-pfn-device-text]'), th = box.querySelector('[data-pfn-device-thumb]'), btn = box.querySelector('[data-pfn-picker]');
      text.replaceChildren();
      if (model) { text.append(document.createTextNode('Jouw toestel')); text.append(el('strong', '', model)); btn.textContent = 'Wijzig'; btn.setAttribute('aria-label', 'Toestel wijzigen, nu ' + model); }
      else { text.append(document.createTextNode('Kies je toestel')); text.append(el('strong', '', 'Zie wat past')); btn.textContent = 'Kies'; btn.setAttribute('aria-label', 'Kies je toestel'); }
      const photo = model && cfg.modelPhotos ? cfg.modelPhotos[model] : '';
      if (photo) { th.replaceChildren(); const i = el('img'); i.src = photo; i.alt = ''; i.width = 88; i.height = 88; th.append(i); }
    });
    document.querySelectorAll('[data-pfn-acc-title]').forEach(n => { n.textContent = model ? 'Accessoires voor ' + model : 'Accessoires'; });
    document.querySelectorAll('[data-pfn-acc-for]').forEach(n => { n.textContent = model ? 'Voor ' + model : 'Bescherming en opladen'; });
  }
  function ensureCss() {
    if (!cfg.accessoryCss || document.querySelector('link[data-pfn-acc-css], link[href*="pf-accessory.css"]')) return;
    const l = el('link'); l.rel = 'stylesheet'; l.href = cfg.accessoryCss; l.dataset.pfnAccCss = '1'; document.head.append(l);
  }
  // Generieke afhandeling voor het header-sjabloon (de categorie- en productpagina binden hun eigen modelkiezer).
  function bindGeneric(picker) {
    const chips = [...picker.querySelectorAll('[data-pf-series]')], cards = [...picker.querySelectorAll('[data-pf-model-card]')];
    const search = picker.querySelector('[data-pf-picker-search]'), none = picker.querySelector('[data-pf-picker-none]');
    const remember = picker.querySelector('[data-pf-picker-remember]'), clear = picker.querySelector('[data-pf-picker-clear]');
    const confirm = picker.querySelector('[data-pf-picker-confirm]'), label = picker.querySelector('[data-pf-picker-confirm-label]');
    let series = (chips.find(c => c.getAttribute('aria-pressed') === 'true') || chips[0] || {}).dataset ? (chips.find(c => c.getAttribute('aria-pressed') === 'true') || chips[0]).dataset.pfSeries : '';
    const selected = () => { const i = picker.querySelector('input[name="pf-picker-model"]:checked'); return i ? i.value : ''; };
    const sync = () => { const m = selected(); confirm.disabled = !m; label.textContent = m ? 'Toon accessoires voor ' + m : 'Kies eerst je model'; cards.forEach(c => c.classList.toggle('is-selected', c.dataset.model === m)); };
    const showSeries = n => { series = n; chips.forEach(c => c.setAttribute('aria-pressed', String(c.dataset.pfSeries === n))); cards.forEach(c => { c.hidden = c.dataset.series !== n; }); if (none) none.hidden = true; };
    chips.forEach(c => c.addEventListener('click', () => { search.value = ''; showSeries(c.dataset.pfSeries); }));
    search.addEventListener('input', () => {
      const q = search.value.trim().toLowerCase().replace(/\s+/g, ' ');
      if (!q) { showSeries(series); return; }
      let shown = 0; chips.forEach(c => c.setAttribute('aria-pressed', 'false'));
      cards.forEach(c => { const n = c.dataset.model.toLowerCase(); const hit = n.includes(q) || n.replace('iphone ', '').startsWith(q); c.hidden = !hit; if (hit) shown++; });
      if (none) none.hidden = shown > 0;
    });
    search.addEventListener('keydown', e => { if (e.key === 'Enter') e.preventDefault(); });
    picker.addEventListener('change', e => { if (e.target.name === 'pf-picker-model') sync(); });
    if (remember) remember.checked = true;
    clear.addEventListener('click', () => { writeDevice(''); clear.hidden = true; refreshDevice(); });
    // Zonder accessoirelijst op deze pagina: onthouden (schakelaar) en direct naar de passende accessoires voor dit model,
    // via het bestaande modelfilter van de categoriepagina (pf_model). Hoesjes eerst; de categorietabs leiden naar glas, kabels enz.
    confirm.addEventListener('click', () => { const m = selected(); if (!m) return; if (!remember || remember.checked) writeDevice(m); picker.close(); refreshDevice();
      const u = new URL(cfg.fitUrl || '/collections/telefoon-hoesjes', location.origin); u.searchParams.set('pf_model', m); location.href = u.pathname + u.search; });
    picker.addEventListener('pf:sheet:open', () => {
      const saved = readDevice();
      clear.hidden = !saved;
      const card = saved && cards.find(c => c.dataset.model === saved);
      if (card) { card.querySelector('input').checked = true; showSeries(card.dataset.series); } else showSeries(series);
      sync();
    });
  }
  function openPicker(trigger) {
    let picker = document.getElementById('pf-model-picker');
    if (!picker) {
      const tpl = document.querySelector('[data-pfn-picker-template]');
      if (!tpl) return;
      ensureCss();
      document.body.append(tpl.content.cloneNode(true));
      picker = document.getElementById('pf-model-picker');
      if (!picker) return;
      picker.dataset.pfnGeneric = '1';
      bindGeneric(picker);
    }
    picker.addEventListener('pf:sheet:close', refreshDevice, { once: true });
    picker.addEventListener('close', refreshDevice, { once: true });
    // Lade of dropdown dicht, zodat er hooguit één laag tegelijk open is.
    closeAll();
    if (drawer && drawer.classList.contains('is-open')) { const c = drawer.querySelector('[data-pf-menu-close]'); if (c) c.click(); }
    if (window.pfSheetOpen) window.pfSheetOpen('pf-model-picker', trigger);
    else if (picker.showModal) { picker.showModal(); picker.dispatchEvent(new CustomEvent('pf:sheet:open', { bubbles: true })); }
  }
  document.addEventListener('click', e => { const t = e.target.closest('[data-pfn-picker]'); if (t) { e.preventDefault(); openPicker(t); } });
  window.addEventListener('storage', e => { if (e.key === STORE) refreshDevice(); });
  refreshDevice();
})();
